import React, { Component, Fragment } from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';
import {Grid} from '@material-ui/core'
import withStyles from "@material-ui/core/styles/withStyles";
import style from "../../../containers/app/AppContainerStyles";
import MonthSelect from "../../../components/Filter/MonthSelect";
import YearSelect from "../../../components/Filter/YearSelect";
import {monthsFilterTable} from "../../../actions/accountingActions";
import MonthYearSelect from "../../../components/Filter/MonthYearSelect";
import {filterTable} from "../../../actions/waiterActions";
import WaiterStatusSelect from "../../../components/Filter/WaiterStatusSelect";

function WaitersFilter(){

    return (
        <Fragment>
            <Grid container spacing={5} style={{border: '1px solid #262c46', width: '100%', margin: 0}}>
                <Grid item md={3} xs={12}>
                    <WaiterStatusSelect
                        fieldName={'status'}
                    />
                </Grid>
            </Grid>
        </Fragment>
    );
}

function mapStateToProps(state) {
    return {
        initialValues: {
            status: ['active']
        },
    }
}
const mapDispatchToProps = {
    setFilter: filterTable
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    reduxForm({
        form: 'waiters-filter-form',
        enableReinitialize: true,
        onChange: (values, dispatch, props, previousValues) => {
            dispatch(props.setFilter({
                values: {
                    status: values.status?values.status:null,
                    restaurant_id: props.restaurant_id
                }
            }));
        },
    }),
    (withStyles(style)),
)(WaitersFilter)